export var entityTypeNameFor = function (entity) {
  var schema = entity && entity._schema || {};
  // @ts-ignore
  return (schema.entityTypeName || (entity === null || entity === void 0 ? void 0 : entity.entityTypeName) || (entity === null || entity === void 0 ? void 0 : entity.__type) || (entity === null || entity === void 0 ? void 0 : entity.__typename) || 'entity').replace(/Platform\_/, '');
};